"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.googleAdsSitelinkManagement = exports.googleAdsSitelinkManagementArgsSchema = exports.GoogleAdsSitelinkAction = void 0;
var zod_1 = require("zod");
var common_1 = require("./common");
// ---------- Add Sitelink ----------
var googleAdsAddSitelinkInputSchema = zod_1.z
    .object({
    campaignId: zod_1.z
        .string()
        .nullish()
        .describe('The campaign ID to attach the sitelink to (required if assetGroupId and adGroupId are not provided).'),
    assetGroupId: zod_1.z
        .string()
        .nullish()
        .describe('Optional asset group ID to attach the sitelink to (for Performance Max campaigns).'),
    adGroupId: zod_1.z
        .string()
        .nullish()
        .describe('Optional ad group ID to attach the sitelink to (for Search/Display campaigns).'),
    linkText: zod_1.z
        .string()
        .min(1)
        .max(25, 'Link text must be 25 characters or less')
        .describe('The sitelink text that will be displayed. CRITICAL: Maximum 25 characters (including spaces). Count characters BEFORE calling. Examples: "Shop New Arrivals" (18 chars), "Contact Us" (10 chars), "View Pricing" (12 chars).'),
    finalUrl: zod_1.z
        .string()
        .url('Must be a valid URL')
        .describe('The destination URL when the sitelink is clicked. Must be a valid, complete URL including https:// (e.g., "https://example.com/page").'),
    description1: zod_1.z
        .string()
        .max(35, 'Description line 1 must be 35 characters or less')
        .nullish()
        .describe('Optional first description line. CRITICAL: Maximum 35 characters (including spaces). Count characters BEFORE calling. Example: "Browse our latest collection" (30 chars).'),
    description2: zod_1.z
        .string()
        .max(35, 'Description line 2 must be 35 characters or less')
        .nullish()
        .describe('Optional second description line. CRITICAL: Maximum 35 characters (including spaces). Count characters BEFORE calling. Example: "Free shipping on orders over $50" (35 chars).'),
})
    .describe('Add a sitelink extension to a Google Ads campaign, asset group, or ad group.');
var googleAdsAddSitelinkArgsSchema = (0, common_1.GoogleAdsNodeArgsSchema)(googleAdsAddSitelinkInputSchema);
var googleAdsAddSitelinkResponseSchema = zod_1.z.object({
    success: zod_1.z.boolean(),
    sitelinkId: zod_1.z.string().describe('The ID of the created sitelink asset'),
    linkTarget: zod_1.z
        .enum(['campaign', 'assetGroup', 'adGroup'])
        .describe('The type of entity the sitelink is linked to'),
    message: zod_1.z.string().nullish().describe('Additional information about the sitelink creation'),
});
var googleAdsAddSitelinkResultSchema = googleAdsAddSitelinkResponseSchema;
// ==========================
// Compound Tool: googleAdsSitelinkManagement
// ==========================
exports.GoogleAdsSitelinkAction = zod_1.z.enum(['addSitelink']);
exports.googleAdsSitelinkManagementArgsSchema = zod_1.z.object({
    action: zod_1.z.discriminatedUnion('name', [
        zod_1.z.object({
            name: zod_1.z.literal('addSitelink'),
            params: googleAdsAddSitelinkArgsSchema.shape.args,
        }),
    ]),
    emitMode: zod_1.z.literal('single'),
});
var GoogleAdsSitelinkManagementAllResultsSchema = googleAdsAddSitelinkResultSchema;
var googleAdsSitelinkManagementResultSchemas = (0, common_1.defineDynamicSchemas)()({
    dependencies: ['action.name'],
    variants: [
        { when: { 'action.name': 'addSitelink' }, schema: googleAdsAddSitelinkResultSchema },
    ],
    defaultSchema: GoogleAdsSitelinkManagementAllResultsSchema,
});
exports.googleAdsSitelinkManagement = (0, common_1.createToolMetadata)({
    id: 'googleAdsSitelinkManagement',
    displayName: 'Google Ads Sitelink Management',
    displayDescription: 'Add sitelink extensions to Google Ads campaigns',
    category: 'ads',
    color: common_1.BRAND_COLORS.GOOGLE_ADS,
    backgroundColor: (0, common_1.createBgColor)(common_1.BRAND_COLORS.GOOGLE_ADS),
    icon: 'google_ads',
    argsSchema: exports.googleAdsSitelinkManagementArgsSchema,
}, googleAdsSitelinkManagementResultSchemas);
